export default __webpack_public_path__ + "static/media/calendar.a9127b31.svg";